import tickNew from "../../assets/img/tick-new.svg";
import NameIcon from "../../assets/img/nameIcon.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import useTranslator from "../../hooks/useTranslator";
import { useEffect, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { getDocumentTooltipKeys } from "../../Utils/documentGlossaryMap";
import { docsMap } from "../../Utils/skorLiteDocumentMap";

const DocItem = ({
  docFound,
  docItem,
  docName,
  docsData,
  rawDocType,
  translationFromFixed,
  handleInitiateClave,
  index,
  haveClavePinDoc,
  showWelcomePopup,
  isFormSubmitted,
  payslipWarning,
  hideClave = false,
}) => {
  console.log("DocItem rendered", docsData);
  const { _t } = useTranslator();
  const isMobile = useMediaQuery({ maxWidth: 667 });
  const tooltipKeys = getDocumentTooltipKeys(rawDocType, docsMap);
  const tooltipId = `doc-glossary-tooltip-${index}-${(rawDocType || "doc")
    .toString()
    .replace(/[^a-zA-Z0-9]/g, "")}`;
  const firstItemRef = useRef(null);
  const [itemHeight, setItemHeight] = useState(null);

  useEffect(() => {
    if (firstItemRef.current) {
      const height = firstItemRef.current.offsetHeight;
      setItemHeight(height);
    }
  }, []);

  return (
    <div className="doc-listing-div position-relative">
      <div
        className={`d-flex align-items-center gap-2 justify-content-between ${
          docItem || isFormSubmitted ? "docomentList" : "docomentList2"
        }`}
      >
        <div className="d-flex align-items-center gap-2">
          <div className="d-flex align-items-center">
            <img src={"/images/docIconGreen.svg"} alt="logo" />
          </div>
          <div>
            <h6
              className={`d-flex align-items-center doc-name-tooltip-row ${
                docItem ? "cursor-pointer hover-underline" : ""
              }`}
              onClick={() => {
                if (docItem) {
                  window.open(`${docItem?.url}`, "_blank");
                }
              }}
            >
              {translationFromFixed ? _t(docName, "", "fixed") : _t(docName)}
              {tooltipKeys && (
                <>
                  <img
                    src={moreInfoimg}
                    alt=""
                    className="doc-glossary-info-icon"
                    data-tooltip-id={tooltipId}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <ReactTooltip
                    id={tooltipId}
                    place="top"
                    noArrow
                    className="react-tooltip-styling doc-glossary-tooltip"
                    render={() => (
                      <>
                        <p>
                          <strong>
                            {_t("docTooltipWhatItIsLabel", "What it is")}:
                          </strong>{" "}
                          {_t(tooltipKeys.whatItIsKey)}
                        </p>
                        <p>
                          <strong>
                            {_t(
                              "docTooltipWhyWeAskForLabel",
                              "Why we ask for it"
                            )}
                            :
                          </strong>{" "}
                          {_t(tooltipKeys.whyWeAskForKey)}
                        </p>
                      </>
                    )}
                  />
                </>
              )}
            </h6>
            {!hideClave &&
              docsData.CLAVE_DOCS.includes(docName) &&
              (!docItem || docItem?.from === "clave") && (
                <p>
                  {docItem?.from === "clave"
                    ? _t(
                        "downloadedFrom",
                        "in new onboarding flow where document list is shown"
                      )
                    : _t(
                        "availableFrom",
                        "in new onboarding flow where document list is shown"
                      )}
                  <span> Cl@ve Pin</span>
                </p>
              )}
            {payslipWarning && (
              <p
                className="payslip-warning"
                style={{
                  color: "#dc2828",
                  fontSize: "0.75rem",
                  marginTop: "4px",
                  fontWeight: "500",
                }}
              >
                ⚠️ {payslipWarning}
              </p>
            )}
          </div>
        </div>
        {!payslipWarning && (
          <div className="d-flex">
            {(docItem || isFormSubmitted) && <img src={tickNew} alt="" />}
          </div>
        )}
      </div>
      {/* only show hover bar if only doc is from clave */}
      {/* {docsData.CLAVE_DOCS.includes(docName) &&
        !haveClavePinDoc &&
        index === 0 &&
        showWelcomePopup && (
          <div
            onClick={(e) => e.stopPropagation()}
            className="hoverbox-div absolutediv-hover docItemHeight hideOnMobile"
            style={{
              "--top": index === 0 ? 27.5 : 28 + itemHeight + index * 5,
              "--top-mobile": index === 0 ? 65 : 65 + itemHeight + index * 5,
            }}
          >
            <div className="content-hover-div contentHoverDiv">
              <div className="d-flex align-items-center gap-2">
                <img className="logiicon" src={NameIcon} alt="icon" />
                <p>
                  {_t("getFastTrackedLandlordsPreferToReceive")}
                  {_t("documentsVia")} Cl<span>@</span>ve Pin
                </p>
              </div>
              <div className="d-flex justify-content-end getNowButtonWrapper">
                <button
                  onClick={handleInitiateClave}
                  type="button"
                  className="btnNext get-back-btn cursor-pointer"
                >
                  {_t("getNow")}
                </button>
              </div>
            </div>
          </div>
        )} */}
    </div>
  );
};

export default DocItem;
